import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import MemberProductCard from '../convention/memberProductCard';
import { deriveCartConvention, filterAddonProducts } from '../../lib/cartAddons';

/**
 * "Add more" upsell shown on the cart page when the cart contains products that
 * were added from a convention. It surfaces the convention's member products
 * (ammo etc.) as optional extras, hiding the signup fee (not a member product)
 * and anything already in the cart.
 */
@observer
class CartConventionAddons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            products: [],
            loading: true,
            addedToCart: {},
            conventionId: 0,
            customer: 0,
        };
    }

    loadProducts = async () => {
        const { userStore, productStore } = this.props.stores;
        const { user = {} } = userStore;
        const { cart = [] } = user;
        const { conventionId, customer } = deriveCartConvention(cart);
        if (!conventionId || !customer) {
            this.setState({ loading: false, conventionId: 0, customer: 0 });
            return;
        }
        // Same participant-gated route as the convention page; the generic
        // /api/products/ list is scoped to the caller's own user.customer and
        // returns nothing for members of other clubs.
        const products = await productStore.load({
            url: `/api/conventions/${conventionId}/member-products`,
            skipFilter: true,
            addData: [],
            limit: 50,
            skipUpdate: true,
        });
        this.setState({
            products: products || [],
            loading: false,
            conventionId,
            customer,
        });
    }

    addToCart = async (product) => {
        const { userStore } = this.props.stores;
        const { conventionId } = this.state;
        if (!product) {
            return;
        }
        await userStore.addToCart({
            product: product.id,
            qty: 1,
            conventionId,
        });
        this.setState(prev => ({
            addedToCart: { ...prev.addedToCart, [product.id]: true },
        }));
    }

    componentDidMount() {
        this.loadProducts();
    }

    render() {
        const { products, loading, conventionId, addedToCart } = this.state;
        const { userStore } = this.props.stores;
        const { user = {} } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');
        const { cart = [] } = user;

        if (loading || !conventionId) {
            return null;
        }

        const addonProducts = filterAddonProducts(products, cart);
        if (addonProducts.length === 0) {
            return null;
        }

        const compactOpts = { darkmode, cart, addedToCart, convention: null, compact: true };

        return (<>
            <div class='font-weight-lighter px-3 mt-4 box-header d-flex flex-row justify-content-between mb-1'>
                <span>
                    <i class='fa-duotone fa-cart-plus me-2' />
                    <Text id='cart.add-more-title'>Add more to your order</Text>
                </span>
            </div>
            <div class='mt-0 mb-1 mx-3 px-2 py-2 rounded bg-body-tertiary'>
                <div class='text-body-secondary mb-2' style='font-size: 0.8rem;'>
                    <Text id='cart.add-more-subtitle'>Optional extras for the event</Text>
                </div>
                <div class='d-flex gap-2 pb-1' style='overflow-x: auto; -webkit-overflow-scrolling: touch;'>
                    {addonProducts.map(product => (
                        <MemberProductCard
                            key={product.id}
                            {...compactOpts}
                            product={product}
                            onAddToCart={this.addToCart}
                        />
                    ))}
                </div>
            </div>
        </>);
    }
}

export default CartConventionAddons;
